module.exports = __webpack_public_path__ + "img/20_21-Hemorrhoid.cb611965.png";